/**
 * The support page — the URL App Store Connect's support field points at
 * (guideline 1.5), and where Settings › About › Support in the app lands.
 * Assembly only: the copy is `SupportContent` (router-free, unit-tested); this
 * file owns the route, the `<main>` landmark, the column the prose sits in,
 * and the footer that carries the privacy policy link and the way back into
 * the rest of the site.
 */

import { createFileRoute } from "@tanstack/react-router";
import { StyleSheet, View } from "react-native";
import { Footer } from "@/components/marketing/footer";
import { PageColumn } from "@/components/page-column";
import { SupportContent } from "@/components/support-content";
import { spacing } from "@/theme/tokens";

export const Route = createFileRoute("/support")({
  component: SupportPage,
  head: () => ({ meta: [{ title: "Support — Sparkie" }] }),
});

const CONTACT = (import.meta.env.VITE_REMOVAL_CONTACT ?? "").trim();

function SupportPage() {
  return (
    <PageColumn>
      <View role="main" style={styles.page}>
        <SupportContent contact={CONTACT} />
      </View>
      <Footer />
    </PageColumn>
  );
}

const styles = StyleSheet.create({
  page: {
    gap: spacing.xl,
    // The same readable measure and gutter as the privacy policy.
    maxWidth: 760,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.xl,
  },
});
